import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.boltin.com';
const SUPPLIERS_API_PATH = '/api/suppliers';

const fetchSuppliers = async (params = {}) => {
  const response = await axios.get(`${API_BASE_URL}${SUPPLIERS_API_PATH}`, { params });
  return response.data;
};

// Convenience alias returning the data array for simple dropdowns
const getSuppliers = async () => {
  const response = await axios.get(`${API_BASE_URL}${SUPPLIERS_API_PATH}`);
  return response.data.data || response.data || [];
};

const getSupplier = async (id) => {
  const response = await axios.get(`${API_BASE_URL}${SUPPLIERS_API_PATH}/${id}`);
  return response.data.data;
};

const createSupplier = async (payload) => {
  const response = await axios.post(`${API_BASE_URL}${SUPPLIERS_API_PATH}`, payload);
  return response.data.data;
};

const updateSupplier = async (id, payload) => {
  const response = await axios.put(`${API_BASE_URL}${SUPPLIERS_API_PATH}/${id}`, payload);
  return response.data.data;
};

const deleteSupplier = async (id) => {
  await axios.delete(`${API_BASE_URL}${SUPPLIERS_API_PATH}/${id}`);
};

const supplierService = {
  fetchSuppliers,
  getSuppliers,
  getSupplier,
  createSupplier,
  updateSupplier,
  deleteSupplier,
};

export default supplierService;
